let mapping = []
import apiFetch from "@wordpress/api-fetch";

const loadMobileMenu = () => {
    return new Promise(resolve => {
        apiFetch({ path: '/theme/v1/menu' }).then(menu => {
            document.querySelector('.theme-header .mobile-menu .inner').innerHTML = menu.html
            resolve()
        })
    })
}

const showMobileMenu = () => {
    document.querySelector('.theme-header .mobile-menu')?.classList.add('shown')
}

const hideMobileMenu = () => {
    document.querySelector('.theme-header .mobile-menu')?.classList.remove('shown')
}

const load = async () => {
    await loadMobileMenu()

    Array.from(document.querySelectorAll('.theme-header .mobile-menu a')).forEach(link => {
        link.addEventListener('click', () => {
            setTimeout(hideMobileMenu, 0)
        })
    })

    document.querySelector('.menu-burger')?.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()
        showMobileMenu()
    })

    document.querySelector('.menu-close')?.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()
        hideMobileMenu()
    })

    const reloadMapping = (checkHash = false) => {
        mapping = []
        Array.from(document.querySelectorAll('a[href^="/#"]')).forEach(link => {
            const targetAnchor = link.getAttribute('href').replace('/#', '')

            if (targetAnchor) {
                const target = document.getElementById(targetAnchor)
                if (target) {
                    mapping.push({
                        link,
                        target,
                    })
                }
            }
        })

        if (checkHash) {
            if (location.hash) {
                const mappingEntry = mapping.find(m => m.link.getAttribute('href') === '/' + location.hash)
                if (mappingEntry) {
                    scrollToLinkTarget(mappingEntry.link)
                }
            }
        }
    }

    const checkScroll = () => {
        if (location.pathname !== '/') {
            return
        }

        const scrollPosition = window.scrollY + document.querySelector('header.theme-header').getBoundingClientRect().height

        let current = null

        for (const m of mapping) {
            if (m.target.offsetTop <= scrollPosition) {
                current = m
                continue
            }
            break
        }

        if (current) {
            Array.from(document.querySelectorAll('.current-menu-item')).forEach(link => {
                link.classList.remove('current-menu-item')
            })

            const target = '/#' + current.link.href.split('#').pop()
            Array.from(document.querySelectorAll(`a[href="${target}"]`)).forEach(link => {
                link.parentNode.classList.add('current-menu-item')
            })
        }
    }

    const scrollToLinkTarget = (link) => {
        const isHome = location.pathname === '/' && link.getAttribute('href') === '/#home'

        const mappingEntry = mapping.find(m => m.link === link)

        if (!isHome && !mappingEntry) {
            return
        }

        let top = isHome ? 0 : mappingEntry.target.offsetTop - document.querySelector('header.theme-header').getBoundingClientRect().height + 1

        window.scrollTo({top, behavior: 'smooth'});
        return true
    }

    Array.from(document.querySelectorAll('a[href^="/#"]')).forEach(link => {
        link.addEventListener('click', function (e) {
            if (link.classList.contains('menu-burger')) {
                return
            }

            if (link.classList.contains('menu-close')) {
                return
            }

            if (scrollToLinkTarget(link)) {
                e.preventDefault()
                e.stopPropagation()
            }
        })
    })

    reloadMapping(true)
    checkScroll()

    window.addEventListener('scroll', checkScroll)
    window.addEventListener('resize', reloadMapping)
}

window.addEventListener('load', load)